import React from 'react';

/**
 * Badge component for status indicators and labels
 * Supports phase variants, standard colors, and outline style
 */
const Badge = ({ 
  children, 
  variant = 'primary',
  size = 'md',
  className = '',
  ...props 
}) => {
  const baseStyles = 'inline-flex items-center font-semibold rounded-full transition-gentle';
  
  // Helper to resolve variant class based on type
  const resolveVariantClass = (variant) => {
    // Phase variants
    if (variant.startsWith('phase.')) {
      const phase = variant.split('.')[1];
      const phaseColors = {
        stabilize:  'bg-[var(--surface-soft-1)] text-[var(--brand-green-deep)] border border-[rgba(31,42,36,0.12)]',
        understand: 'bg-[var(--surface-soft-2)] text-[var(--brand-green-deep)] border border-[rgba(31,42,36,0.12)]',
        rebuild:    'bg-[var(--surface-soft-3)] text-[var(--brand-green-deep)] border border-[rgba(31,42,36,0.12)]',
        sustain:    'bg-[var(--surface-soft-4)] text-[var(--brand-green-deep)] border border-[rgba(31,42,36,0.12)]',
      };
      return phaseColors[phase] || phaseColors.stabilize;
    }
    
    // Standard variants
    const variants = {
      primary:   'bg-[var(--surface-soft-1)] text-[var(--brand-green-deep)] border border-[rgba(31,42,36,0.15)]',
      secondary: 'bg-[var(--surface-soft-2)] text-[var(--text-primary)] border border-[rgba(31,42,36,0.12)]',
      accent:    'bg-[var(--gold-accent)] text-[var(--gold-accent-text)] border border-transparent',
      success:   'bg-success/10 text-success border border-success/20',
      warning:   'bg-warning/10 text-warning border border-warning/20',
      error:     'bg-error/10 text-error border border-error/20',
      neutral:   'bg-[var(--surface-soft-1)] text-[var(--text-muted)] border border-[rgba(31,42,36,0.1)]',
      outline:   'bg-transparent text-[var(--text-primary)] border-2 border-[rgba(31,42,36,0.2)]',
    };
    
    return variants[variant] || variants.primary;
  };
  
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };
  
  return (
    <span
      className={`${baseStyles} ${resolveVariantClass(variant)} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
